import NglStore from './NglStore.js'
import * as NGL from 'ngl'

const state = {
  instances: {}
}

const mutations = {
  addInstance (state, {id, instance}) {
    state.instances[id] = instance
  }
}

const actions = {
  newInstance ({commit}, {el, id, par}) {
    return new Promise((resolve) => {
      let instance = new NglStore()
      instance.stage = new NGL.Stage(el, par)

//      let id = Math.floor(Math.random() * 1000000)

      commit('addInstance', {id, instance})

      resolve(instance, id)
    })
  },

  updateInstance ({getters}, id) {
    let instance = getters.instance(id)
    return new Promise((resolve) => {
      resolve(instance)
    })
  }
}

const getters = {
  instance: (state) => id => {
    return state.instances[id]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
